import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center pa-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_items = _resolveComponent("v-toolbar-items")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dialog) = $event)),
      transition: "dialog-bottom-transition",
      fullscreen: "",
      class: "bg-grey-lighten-1"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "bg-grey-lighten-1" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_toolbar, { class: "bg-grey-lighten-1" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_toolbar_title, null, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode("Majed Photograph", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_toolbar_items, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      icon: "mdi-close",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeDialog()))
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_list, { class: "bg-grey-lighten-1" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_subheader, null, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode("Übersicht", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_list_item, {
                  color: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollToSection('TESTIMONIALS')))
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_icon, { color: "green-darken-2" }, {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createTextVNode("mdi-account-group", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createTextVNode("Kundenstimmen", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_list_item, {
                  color: "primary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scrollToSection('METHODOLOGY')))
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_icon, { color: "orange-darken-2" }, {
                      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                        _createTextVNode("mdi-lightbulb-on-outline", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                        _createTextVNode("Methodik", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_list_item, {
                  color: "primary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.scrollToSection('PROJECTS')))
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_icon, { color: "blue-darken-2" }, {
                      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                        _createTextVNode("mdi-briefcase-outline", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                        _createTextVNode("Projekte", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_list_item, {
                  color: "primary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.scrollToSection('AQ')))
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_icon, { color: "purple-darken-2" }, {
                      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                        _createTextVNode("mdi-comment-multiple-outline", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                        _createTextVNode("Q&A", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_list_item, {
                  color: "primary",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.scrollToSection('ABOUT_ME')))
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_icon, { color: "pink-darken-2" }, {
                      default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                        _createTextVNode("mdi-account-circle-outline", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                        _createTextVNode("Über mich", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_list_item, {
                  color: "primary",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.scrollToSection('CONTACT')))
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_icon, { color: "red-darken-2" }, {
                      default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                        _createTextVNode("mdi-email-outline", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                        _createTextVNode("Anfrage", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_list_item, {
                  color: "primary",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.scrollToSection('SOCIAL_MEDIA')))
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_icon, { color: "cyan-darken-2" }, {
                      default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                        _createTextVNode("mdi-share-variant-outline", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                        _createTextVNode("Social Media", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}